/*
  This file allows is to separates features and add-ons will allow us to add Add-On Bundles in the Future

  Should Match any purchasable Add-On defined in the Backend Code:
  https://github.com/shipstation/shipstation/blob/master/SS.Business/AccountProfile/Enumerations.cs#L3
*/
import {
  AutoSplit,
  InventorySync,
  NonWalletProviderAccess,
  ProductBundles,
  ShippingStrategies,
  SmartRouting,
  InventoryApi,
  ShipStationApiV2,
} from './features';

export const FulfillmentProviderBundle = 'FulfillmentProviderBundle';
export const DropShip = 'DropShip';
export const Cubiscan = 'Cubiscan';
export const ODBC = 'ODBC';
export const ADD_USER = 'add_user';
export const ADD_ANALYTICS_LICENSE = 'analyticslicenses';

/** @typedef {import('./add-on-code').AddOnCode} AddOnCode */

/**
 * @type {Record<AddOnCode, AddOnCode>}
 */
export const AddOns = {
  AutoSplit,
  Cubiscan,
  DropShip,
  FulfillmentProviderBundle,
  InventorySync,
  NonWalletProviderAccess,
  ODBC,
  ProductBundles,
  ShippingStrategies,
  SmartRouting,
  InventoryApi,
  ShipStationApiV2,
};

export const ShipStationApiV2Url = './addonmarketplace?addonActivateModalOpen=true&addonCode=ShipStationApiV2';
export const InventoryApiUrl = './addonmarketplace?addonActivateModalOpen=true&addonCode=InventoryApi';

export const DEFAULT_TRIAL_LENGTH_IN_DAYS = 30;
